// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7787) return "7787.css";
	// return url for filenames based on template
	return "index" + ".css";
};